exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.file-browser-filter-tooltip .tooltip-inner {\n  max-width: 210px;\n}\n", ""]);

